module.exports = __webpack_public_path__ + "img/bimms.8c8b7de5.png";